<template>
  <div class="page">
    <van-popup v-model="show" round :style="{width:'80%'}" :close-on-click-overlay="false"  get-container="body">
      <div class="box">
        <van-form 
          :show-error-message="false" 
          validate-trigger="onSubmit" 
          validate-first
          input-align="right"
          ref="form"
        >
          <van-field
            required
            label="自动成团"
            :rules="[{ required: true, message: '请选择是否自动成团' }]"
          >
            <template #input>
              <van-radio-group 
                v-model="goods.boolAutoGroup" 
                direction="horizontal" 
                icon-size="16px" 
                checked-color="#FF6B31"
                @change="changeAutoGroup"
              >
                <van-radio name="false">关闭</van-radio>
                <van-radio name="true">开启</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            required
            v-if="goods.boolAutoGroup == 'true'"
            v-model="goods.autoGroupTime"
            label="自动成团时间(小时)"
            type="digit"
            label-width="9em"
            placeholder="请输入自动成团时间"
            :rules="[{ required: true, message: '请输入自动成团时间' }]"
            @blur="checkFeeValid('autoGroupTime')"
            :formatter="formatnNumber"
          />
          <span class="tips" v-if="goods.boolAutoGroup == 'true'">超过所设时间，自动成团</span>
          <van-field
            required
            v-model="goods.goodsName"
            label="名称"
            :maxlength="16"
            placeholder="请输入商品名称"
            :rules="[{ required: true, message: '请输入商品名称' }]"
          />
          <van-field
            v-model="goods.oldPrice" 
            label="原价"
            type="number"
            placeholder="请输入原价"
            @blur="checkFeeValid('oldPrice')"
            :formatter="formatter"
          />
          <van-field
            required
            :disabled="isDisabled"
            v-model="goods.singlePrice"
            label="单买价"
            type="number"
            placeholder="请输入单买价"
            :rules="[{ required: true, message: '请输入单买价' }]"
            @blur="checkFeeValid('singlePrice')"
            :formatter="formatter"
          />
          <van-field
            required
            :disabled="isDisabled"
            v-model="goods.teamNumber"
            label="拼团人数"
            type="digit"
            placeholder="请输入拼团人数"
            :rules="[{ required: true, message: '请输入拼团人数' }]"
            @blur="checkFeeValid('teamNumber')"
            :formatter="formatTeamNumber"
          />
          <div class="price">
            <van-field
              required
              input-align="left"
              :maxlength="5"
              v-model="goods.groupBuyTitle"
              placeholder="请输入"
            />
            <van-field
              class="border"
              :disabled="isDisabled"
              v-model="goods.groupBuyPrice"
              type="number"
              placeholder="请输入"
              :rules="[{ required: true, message: '请输入金额' }]"
              @blur="checkFeeValid('groupBuyPrice')"
              :formatter="formatter"
            />
          </div>
          <van-field
            v-model="goods.goodsTag"
            label="标签"
            maxlength="6"
            placeholder="请输入标签"
            :show-error-message="false"
          />
          <van-field 
            required
            name="headImg"  
            label="商品头图"
          >
            <template #input>
              <van-uploader
                :max-count="1" 
                :before-read="beforeImgUpload" 
                :fileList="goods.headImgList" 
                :after-read=" (e) => uploadImg(e,'headImgList')"
                @delete="(file) => deleteImg(file,'headImgList')"
              />
            </template>
          </van-field>
          <van-field
            required
            v-model="goods.goodsNumber"
            :label="isDisabled ? '原库存' : '库存'"
            type="digit"
            placeholder="请输入库存"
            :rules="[{ required: true, message: '请输入库存'}]"
            @blur="checkFeeValid('goodsNumber')"
          />
          <span class="tips" v-if="isDisabled && !isClone">
            当前销售量：{{stockObj.totalNumber || 0}} (实际销售量{{stockObj.soldNumber || 0}},锁定库存{{stockObj.occupyNumber || 0}})
          </span>
          <van-field
            class="border"
            v-model="goods.virtualPeople"
            type="digit"
            label="虚拟拼团人数"
            placeholder="请输入虚拟拼团人数"
            @blur="checkFeeValid('virtualPeople')"
          />
        </van-form>
        <div class="img-box">
          <div class="img-title">商品详情</div>
            <van-uploader 
              class="uploader" 
              :fileList="goods.detailsImg" 
              :max-count="5" 
              result-type="file"
              :before-read="beforeImgUpload" 
              :after-read=" (e) => uploadImg(e,'detailsImg')"
              @delete="(file) => deleteImg(file,'detailsImg')"
            />
        </div>
        <div class="footer" v-show="bottomIsShow">
          <div class="button cancel" @click="onCancel">取消</div>
          <div class="button" @click="onFailed">
            {{from == 'manager' ? '保存并上架' : '保存'}}
          </div>
        </div>
        <div style="height:66px"></div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { round2Places } from "@/utils/utils";
export default {
  props: {
    isAddGoods:{
      type: Boolean,
      default: false
    },
    goods: {
      type: Object,
      default() {
        return {}
      }
    },
    defaultPhoneHeight: {
      type: Number,
    }
  },
  computed: {
    show: {
      get() {
        return this.isAddGoods
      },
      set(newVal) {
        this.$emit('update:isAddGoods', newVal)
      }
    },
    from() {
      return this.$route.query.from
    },
    activityId() {
      return  this.$route.query.activityId || ''
    },
    isClone() {
      return this.$route.query.from == 'clone';
    },
    isDisabled() {
      if (this.from == 'manager' && this.goods.goodsId) {
        return true
      }else {
        return false
      }
    }
  },
  watch:{
    nowPhoneHeight:function(){
      if(this.defaultPhoneHeight != this.nowPhoneHeight){
        // 当软键盘弹出,改变bottomIsSHow变量然后去控制bottom的显示与隐藏
        this.bottomIsShow=false;
      }else{
        // 相等代表软键盘收起后,与上同理
        this.bottomIsShow=true
      }
    },
  },
  data() {
    return {
      isUploadImg: false,
      bottomIsShow:true,//控制底部tabbar显示与隐藏
      nowPhoneHeight:0, //屏幕现在的高度
      stockObj: {}
    }
  },
  methods:{
    changeAutoGroup(type) {
      if (type == 'false') {
        this.goods.autoGroupTime = ''
      }
    },
    checkFeeValid(fieldName) {
      let parame = this.goods[fieldName]
      if (parame > 9999999) {
        parame = 9999999
      }
      if (fieldName == 'goodsNumber' && this.isDisabled && !this.isClone) {
        if (parame < this.stockObj.totalNumber)  {
          this.$toast('原库存不能小于当前销售量')
        }
      }
      this.goods[fieldName] = round2Places(parame)
    },
    beforeImgUpload(file) {
      const acceptTypes = ['image/png', 'image/jpeg', 'image/gif'];
      if (!acceptTypes.includes(file.type)) {
        this.$toast('请上传png、jpg或gif格式图片');
        return false;
      }
      return true;
    },
    uploadImg(file,type) {
      this.isUploadImg = true
      const currentFile = {
        url: '',
        status:'uploading',
        message: '上传中...'
      }
      this.goods[type].push(currentFile)
      this.$api.common.uploadImg(file.file)
        .then(({data}) => {
          if (data && data[0]) {
            const fileUrl = data[0].fileUrl;
            currentFile.url = fileUrl
            currentFile.status = 'done'
            delete this.goods[type][0].status
            delete this.goods[type][0].message
            this.isUploadImg = false
          }
        })
        .catch(err => {
          this.isUploadImg = false
          const currentIndex = this.goods[type].indexOf(currentFile);
          if (currentIndex > -1) {
            this.goods[type].splice(currentIndex, 1);
          }
      });
    },
    deleteImg(file,type) {
      if (type == 'headImgList' && this.goods.isActiveStart) return
      const currentIndex = this.goods[type].indexOf(file);
      if (currentIndex > -1) {
        this.goods[type].splice(currentIndex, 1);
      }
    },
    onFailed() {
      // 图片上传中
      if (this.isUploadImg) return
      const { groupWaitTime, boolAutoGroup, autoGroupTime} = this.goods
      if (boolAutoGroup == 'true' && (groupWaitTime < autoGroupTime)) {
        this.$toast('自动成团时间不能大于成团等待时间')
        return
      }
      this.$refs.form.validate().then(res => {
        if (this.goods.headImgList.length) {
          if (this.from == 'manager' || this.from == 'home') {
            if (this.from == 'manager') {
              if (this.goods.goodsNumber < (this.stockObj.totalNumber || 0)) {
                this.$toast(`库存小于了当前销售量，请重新修改！ 当前销售量为”${this.stockObj.totalNumber}“`)
                return
              }
            }
            const obj = this.initGoodsItem(this.goods)
            this.$api.groupBuying.saveGoodsAndOnline(obj).then(res => {
              if (res.success) {
                this.goods.goodsId = res.data
                this.goods.status = 0
                this.$emit('addGoodsSuccess', this.goods, true)
                this.show = false
                this.$toast('保存成功')
              } 
            })
          }else {
            this.$emit('addGoodsSuccess', this.goods)
            this.show = false
          }
        }else {
          this.$toast('请上传商品头图')
        }
      }).catch(err => {
        this.$toast(err[0].message);
      })
    },
    onCancel() {
      this.form = this.spikeGoods
      this.show = false
    },
    formatter(value) {
      return value.replace(/[^\d.]/g, '');
    },
    formatnNumber(value) {
      if (value == 0 && value) {
        return 1
      }else {
        return value
      }
    },
    formatTeamNumber(value) {
      if (value && value < 2) {
        return 2
      }else {
        return value
      }
    },
    initGoodsItem(obj) {
      obj.headImg = obj.headImgList[0].url
      obj.goodsDetails = []
      if (obj.detailsImg.length) {
          obj.detailsImg.forEach(item => {
          obj.goodsDetails.push(item.url)
        })
      }
      return obj
    },
    goodsSoldNumber() {
      this.$api.groupBuying.goodsSoldNumber(this.goods.goodsId)
        .then(res => {
          this.stockObj = res.data
        })
    }
  },
  mounted() {
    window.onresize = ()=>{ //这个方法会被调用两次,软键盘弹出后和软件收起后
      this.nowPhoneHeight = window.innerHeight 
    }
    if (this.isDisabled) {
      this.goodsSoldNumber()
    }
  },
  destroyed() {
    //页面销毁前要记得这个监听消除掉;
    window.onresize = null
  }
}
</script>

<style lang="stylus" scoped>
.box {
  padding-top: 10px;
  height: 520px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  .tips {
    font-size: 10px;
    color: #bbb;
    padding-left: 16px;
  }
  .img-box {
    padding: 10px 16px;
    .img-title {
      margin-bottom: 6px;
    }
  }
  .price {
    display: flex;
    .van-field {
      flex: 1;
    }
  }
  .border {
    border-bottom: 1px solid #ebedf0;
  }
  .footer {
    box-sizing: border-box
    position absolute;
    left 0
    bottom 0
    padding 0 10px
    height 60px
    width 100%
    display: flex
    align-items: center
    justify-content: space-around
    padding-bottom constant(safe-area-inset-bottom)
    padding-bottom env(safe-area-inset-bottom)
    border-bottom-left-radius: 16px
    border-bottom-right-radius: 16px
    background-color #fff
    .button {
      padding 10px 40px
      border 1px solid $mainTextColor
      border-radius: 8px
      color #fff
      background-color: $mainTextColor
    }
    .cancel {
      color $mainTextColor
      background: #fff;
    }
  }
}
</style>
